import React, { useEffect, useMemo, useState } from "react";
import cx from "./Portal.module.css";
import { Row, Col, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";

export default function UserProfile() {
  let userData = JSON.parse(localStorage?.getItem("fandfData"));

  const caresiteData = useMemo(() => {
    let careSite = localStorage?.getItem("careSite");
    if (careSite) {
      return JSON.parse(careSite);
    }
    return null;
  }, []);

  return (
    <div className={`${cx.profilePage}`}>
      <div className={`container`}>
        <Row>
          <Col lg={4} md={6} sm={12} className={`m-auto`}>
            <div className={`${cx.ProfileBox}`}>
              <div className={`${cx.topHeadeing}`}>
                <h3>My Profile</h3>
                <div className={`${cx.backIcon}`}>
                  <NavLink to="/portal/portal-main">
                    <img src="/admin/images/BackVector.png" alt="" />
                  </NavLink>
                </div>
              </div>
              <div className={`${cx.profileImg}`}>
                <img
                  src={userData?.image !== "" ? userData?.image : ""}
                  alt=""
                />
              </div>
              <div className={`${cx.FromBox}`}>
                <div className={`${cx.box}`}>
                  <label>ID</label>
                  <input
                    disabled
                    type="text"
                    value={`${caresiteData?.careSiteName
                      ?.split(" ")?.[0]
                      ?.toUpperCase()}_${userData?.customId}`}
                  />
                </div>
                <div className={`${cx.box}`}>
                  <label>Name</label>
                  <input disabled type="text" value={userData?.name} />
                </div>
                <div className={`${cx.box}`}>
                  <label>Relation to Client</label>
                  <input
                    disabled
                    type="text"
                    value={userData?.relationship ?? ""}
                  />
                </div>
                <div className={`${cx.box}`}>
                  <label>Care Site</label>
                  <input
                    disabled
                    type="text"
                    value={caresiteData?.careSiteName ?? ""}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
